import { render } from "./BookVariant.vue?vue&type=template&id=7d51b86a"
import script from "./BookVariant.vue?vue&type=script&lang=js"
export * from "./BookVariant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Products/BookVariant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d51b86a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d51b86a', __exports__)) {
    api.reload('7d51b86a', __exports__)
  }
  
  module.hot.accept("./BookVariant.vue?vue&type=template&id=7d51b86a", () => {
    api.rerender('7d51b86a', render)
  })

}


export default __exports__